// withI18nLoader.js
'use strict';

import { getLangFromPath, normalizeLang } from '../resource/langPath.js';
import { DEFAULT_LANGUAGE } from '../resource/i18nCommon.js';
import { createI18nInstance } from '../resource/i18nServer.js';

/**
 * Higher-order function that wraps a loader with i18n initialization.
 * This avoids repeating i18n setup logic in every loader.
 *
 * @param {Function} loader - The original loader function
 * @param {string[]} namespaces - Translation namespaces to load
 * @returns {Function} Wrapped loader with i18nInstance injected
 *
 */
export const withI18nLoader = (loader, namespaces = []) => {
  return async args => {
    const { request } = args;

    const url = new URL(request.url);
    const langFromPath = getLangFromPath(url.pathname);
    const language = langFromPath
      ? normalizeLang(langFromPath)
      : DEFAULT_LANGUAGE;

    const i18nInstance = createI18nInstance();
    await i18nInstance.init();
    await i18nInstance.changeLanguage(language);

    if (namespaces.length > 0) {
      await i18nInstance.loadNamespaces(namespaces);
    }

    return loader({
      ...args,
      i18nInstance,
      language,
    });
  };
};

export default withI18nLoader;
